import { useQueryClient } from '@tanstack/react-query';
import { CardDetailsWithStats } from 'hooks/queries/cards/useCardsDetailsApi';
import useOwnershipListsMutation from 'hooks/useOwnershipListsMutation';
import { OwnershipListsName } from 'hooks/useOwnershipListsMutation/types';
import { useForm } from 'react-hook-form';
import cardsFactory from 'utils/factories/card';

type FormValues = {
  quantity: number;
};

const useAddToTradeList = (card: CardDetailsWithStats, onClose: () => void) => {
  const formMethods = useForm<FormValues>({
    mode: 'onSubmit',
    defaultValues: {
      quantity: card.stats?.inMyTradelist,
    },
  });
  const queryKey = cardsFactory.statsDetails();
  const queryClient = useQueryClient();
  const { mutateAsync } = useOwnershipListsMutation(OwnershipListsName.TRADELIST, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const handleSubmit = formMethods.handleSubmit(async (values) => {
    await mutateAsync({
      cards: [
        {
          card: card?.['@id'] || '',
          quantity: values.quantity,
        },
      ],
    });

    onClose();
  });

  return { formMethods, handleSubmit };
};

export default useAddToTradeList;
